import { ThemeProvider } from 'styled-components';
import { lightTheme } from 'styles/new-theme';
import SVG from 'assets/svgs';
import {
  FooterWrapper,
  SubHeader,
  LinksSectionWrapper,
  LinksWrapper,
  Icon,
  SSLSecuredWrapper,
  Paragraph,
  PayPalIcon,
  SocialsLink,
  BottomSection,
  RightsReservedWrapper,
  LinkButton,
  StyledLink,
  SocialsSection,
  FAQLink,
} from './footer.styles';

const Footer = (): JSX.Element => {
  const handleOpenIntercom = (): void => {
    (window as any).Intercom('show');
  };
  return (
    <ThemeProvider theme={lightTheme}>
      <FooterWrapper>
        <BottomSection>
          <LinksWrapper>
            <LinksSectionWrapper>
              <SubHeader>Help</SubHeader>
              <LinkButton type="button" onClick={handleOpenIntercom}>
                Support
              </LinkButton>
              <FAQLink openInNewTab href="/faq">
                FAQ
              </FAQLink>
            </LinksSectionWrapper>

            <LinksSectionWrapper>
              <SubHeader>More</SubHeader>
              <StyledLink
                href="https://playerslounge.co/terms"
                target="_blank"
                rel="noreferrer"
              >
                Terms of service
              </StyledLink>
              <StyledLink
                href="https://playerslounge.co/privacy"
                target="_blank"
                rel="noreferrer"
              >
                Privacy Policy
              </StyledLink>
              <FAQLink openInNewTab href="/your-data">
                Your data
              </FAQLink>
            </LinksSectionWrapper>
          </LinksWrapper>

          <SocialsSection>
            <div style={{ marginLeft: -8 }}>
              <SocialsLink
                href="https://discord.gg/players-lounge"
                target="blank"
              >
                <Icon icon="logo:discord" alt="Discord" />
              </SocialsLink>
              <SocialsLink
                href="https://www.twitch.com/playerslounge"
                target="blank"
              >
                <Icon icon="platform:twitch" alt="Twitch" />
              </SocialsLink>
              <SocialsLink
                href="https://www.instagram.com/playerslounge"
                target="blank"
              >
                <Icon icon="platform:instagram" alt="Instagram" />
              </SocialsLink>
              <SocialsLink
                href="https://www.facebook.com/playersloungegaming"
                target="blank"
              >
                <Icon icon="platform:facebook" alt="Facebook" />
              </SocialsLink>
              <SocialsLink
                href="https://www.twitter.com/_playerslounge"
                target="blank"
              >
                <Icon icon="platform:twitter" alt="Twitter" />
              </SocialsLink>
            </div>

            <div style={{ display: 'flex', marginTop: 16 }}>
              <SSLSecuredWrapper>
                <Icon icon="status:locked" />
                <span>SSL SECURED</span>
              </SSLSecuredWrapper>
              <PayPalIcon>
                <SVG icon="platform:paypalMuted" />
              </PayPalIcon>
            </div>
          </SocialsSection>
        </BottomSection>
        <RightsReservedWrapper>
          <div>
            <SubHeader>
              {"© 2023 Players' Lounge. All rights reserved."}
            </SubHeader>
            <Paragraph>
              Players’ Lounge is not endorsed by, directly affiliated with,
              maintained or sponsored by Apple Inc, Electronic Arts, Activision
              Blizzard, Take-Two Interactive, Microsoft, Xbox, Sony, Playstation
              or Epic Games. All content, games titles, trade names and/or trade
              dress, trademarks, artwork and associated imagery are trademarks
              and/or copyright material of their respective owners.
            </Paragraph>
          </div>
        </RightsReservedWrapper>
      </FooterWrapper>
    </ThemeProvider>
  );
};

export default Footer;
